var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quantity"},[_c('div',{staticClass:"number-spinner"},[_c('span',{staticClass:"min",on:{"click":_vm.spinnerDown}},[_vm._v("-")]),_vm._v(" "),_c('input',{staticClass:"spinner",attrs:{"type":"text","name":_vm.name,"max":_vm.max,"min":_vm.min},domProps:{"value":_vm.intern_value},on:{"input":_vm.change}}),_vm._v(" "),_c('span',{staticClass:"plus",on:{"click":_vm.spinnerUp}},[_vm._v("+")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-407c11e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Vue/Src/Components/amz-spinner.vue
// module id = 36
// module chunks = 0 1 2